import { FleekError } from './FleekError';

type EnsNameContentHashCodecMistmatchErrorOptions = {
  codec: string;
};

export class EnsNameContentHashCodecMistmatchError extends FleekError<EnsNameContentHashCodecMistmatchErrorOptions> {
  public name = 'EnsNameContentHashCodecMistmatchError';

  toString = () => {
    return `The content hash does not match or does not corresponds to ${this.data.codec} protocol`;
  };
}
